export default __webpack_public_path__ + "static/media/1941.f075de55.png";